import content from '@/api/front/content-management'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState
}

export const getters = {}

export const mutations = {
  ...baseMutations
}

export const actions = {
  fetch(context, attrubutes = {}) {
    return content.get({ params: {
        ...attrubutes
    }})
  }
}
